export const getHeatmapConfigTemp = (name, radius = 20) => {
  return {
    id: "6pv7cen",
    type: "heatmap",
    config: {
      dataId: "tdm_temp",
      label: name,
      color: [218, 112, 191],
      highlightColor: [252, 242, 26, 255],
      columns: {
        lat: "lat",
        lng: "lon",
      },
      isVisible: true,
      visConfig: {
        opacity: 0.8,
        colorRange: {
          name: "Global Warming",
          type: "sequential",
          category: "Uber",
          colors: [
            "#8fcfd2",
            "#77ccd4",
            "#63b4bf",
            "#63a3bf",
            "#5da37d",
            "#63a86e",
            "#4c9e4c",
            "#578d38",
            "#678d38",
            "#718d38",
            "#BFC048",
            "#D0CD1F",
            "#ede909",
            "#edcf09",
            "#eda509",
            "#ed8609",
            "#ef760f",
            "#DE4F0B",
            "#EA0202",
            "#C50404",
          ],
        },
        radius: radius,
      },
      hidden: false,
      weightField: { name: name, type: "float" },
      textLabel: [
        {
          field: null,
          color: [255, 255, 255],
          size: 18,
          offset: [0, 0],
          anchor: "start",
          alignment: "center",
        },
      ],
    },
    visualChannels: {
      weightField: {
        name: name,
        type: "float",
      },
      weightScale: "linear",
    },
  };
};

export const getHeatmapConfigTempNorm = (name, radius = 25) => {
  return {
    id: "6pv7cen",
    type: "heatmap",
    config: {
      dataId: "tdm_temp",
      label: name,
      color: [218, 112, 191],
      highlightColor: [252, 242, 26, 255],
      columns: {
        lat: "lat",
        lng: "lon",
      },
      isVisible: true,
      visConfig: {
        opacity: 0.8,
        colorRange: {
          name: "Global Warming",
          type: "sequential",
          category: "Uber",
          colors: [
            // "#8fcfd2",
            // "#77ccd4",
            // "#63b4bf",
            // "#63a3bf",
            // "#5da37d",
            // "#63a86e",
            // "#4c9e4c",
            // "#578d38",
            // "#678d38",
            // "#718d38",
            // "#BFC048",
            // "#D0CD1F",
            // "#ede909",
            // "#edcf09",
            // "#eda509",
            // "#ed8609",
            // "#ef760f",
            // "#DE4F0B",
            // "#EA0202",
            // "#C50404",
            "#8fcfd2",
            "#63b4bf",
            "#578d38",
            "#678d38",
            "#ede909",
            "#edcf09",
            "#ed8609",
            "#DE4F0B",
            "#EA0202",
            "#C50404"
          ],
        },
        radius: radius,
      },
      hidden: false,
      weightField: { name: 'data_norm', type: "float" },
      textLabel: [
        {
          field: null,
          color: [255, 255, 255],
          size: 18,
          offset: [0, 0],
          anchor: "start",
          alignment: "center",
        },
      ],
    },
    visualChannels: {
      weightField: {
        name: 'data_norm',
        type: "float",
      },
      weightScale: "linear",
    },
  };
};